import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';

import styles from './MapContainer.module.scss';
import ICONS from '../../static/media/icons/icons-helper';

const API_KEY = 'AIzaSyCsZHVBFA54h17to9twbHLuBB3x5olytLY';

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '220px',
};

const mapOptions = { fullscreenControl: false, zoomControl: false };
const initialCoordinates = [38.7589703, -94.3880433];

const MapContainer = ({ events, selectedEvent }) => {
  const [mapInstance, setMapInstance] = useState(null);
  const [mapApi, setMapApi] = useState(null);

  const fitToBounds = (map, maps, places) => {
    if (maps) {
      const bounds = new maps.LatLngBounds();

      const placesWithCoordinates = places.filter(
        (place) => place.lat && place.lng
      );

      placesWithCoordinates.forEach((event) => {
        if (event.lat && event.lng)
          bounds.extend(new maps.LatLng(event?.lat, event?.lng));
      });

      if (placesWithCoordinates.length > 0) {
        map.fitBounds(bounds);
        if (placesWithCoordinates.length === 1) map.setZoom(15);
      }
    }
  };

  useEffect(() => {
    if (selectedEvent && events.length === 1)
      fitToBounds(mapInstance, mapApi, [selectedEvent]);
    else fitToBounds(mapInstance, mapApi, events);
    return () => {};
  }, [mapApi, mapInstance, events, selectedEvent]);

  const handleGoogleApiLoaded = ({ map, maps }) => {
    setMapInstance(map);
    setMapApi(maps);
    fitToBounds(map, maps, events);
  };

  const DotMarker = () => <div className={styles.markerStyle} />;

  const CommonMarker = () => <img src={ICONS.MARKER} alt="marker-img" />;

  const renderMarker = (event) => {
    let marker = null;
    if (
      selectedEvent &&
      selectedEvent.lat === event.lat &&
      selectedEvent.lng === event.lng
    ) {
      if (!selectedEvent.lat || !selectedEvent.lng) return null;
      marker = (
        <CommonMarker
          key={event.id}
          lat={selectedEvent.lat}
          lng={selectedEvent.lng}
        />
      );
    } else {
      if (!event.lat || !event.lng) return null;
      if (events.length === 1) {
        marker = (
          <CommonMarker key={event.id} lat={event.lat} lng={event.lng} />
        );
      } else
        marker = <DotMarker key={event.id} lat={event.lat} lng={event.lng} />;
    }

    return marker;
  };

  return (
    <div style={containerStyle}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: API_KEY }}
        defaultCenter={initialCoordinates}
        defaultZoom={4}
        options={mapOptions}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={handleGoogleApiLoaded}
      >
        {events.map(renderMarker)}
      </GoogleMapReact>
    </div>
  );
};

MapContainer.propTypes = {
  events: PropTypes.instanceOf(Array),
  selectedEvent: PropTypes.instanceOf(Object),
};

MapContainer.defaultProps = {
  events: [],
  selectedEvent: null,
};

export default MapContainer;
